module.exports = __webpack_public_path__ + "img/irrigation-control-2.e077e823.jpg";